export function toUrlFriendly(str: string): string {
  return str.toLowerCase().replace(/ & /g, "-").replace(/\s+/g, "-");
}

const categoryMap: Record<string, string> = {
  "health-wellness": "Health & Wellness",
  "home-garden": "Home & Garden",
  automotive: "Automotive",
  "kitchen-dining": "Kitchen & Dining",
  "tech-gadgets": "Tech & Gadgets",
  "travel-outdoors": "Travel & Outdoors",
  "apparel-accessories": "Apparel & Accessories",
};

export function fromUrlFriendly(urlFriendlyName: string): string {
  return categoryMap[urlFriendlyName] || urlFriendlyName;
}

export function stripHtml(str: string): string {
  // Strip HTML tags
  let cleaned = str.replace(/<[^>]*>/g, " ");
  // Remove common internal marketing brief patterns
  cleaned = cleaned.replace(/Marketing Brief:.*$/s, "");
  cleaned = cleaned.replace(/Creative Assets:.*$/s, "");
  cleaned = cleaned.replace(/https?:\/\/\S+/g, "");
  cleaned = cleaned.replace(/LINK\b/g, "");
  // Collapse whitespace
  cleaned = cleaned.replace(/\s+/g, " ").trim();
  return cleaned;
}

/**
 * Strip non-USD currency prefixes/suffixes from price strings.
 * Defensive fallback for stale DB data that still has AUD/EUR/etc.
 */
export function normalizePrice(price: string): string {
  return price
    .replace(/\b(AUD|EUR|GBP|CAD|NZD|CHF|JPY|CNY|KRW|SEK|NOK|DKK|SGD|HKD|MXN|BRL|INR|ZAR)\s*/gi, "")
    .replace(/\s*(AUD|EUR|GBP|CAD|NZD|CHF|JPY|CNY|KRW|SEK|NOK|DKK|SGD|HKD|MXN|BRL|INR|ZAR)\b/gi, "")
    .trim();
}

export function formatPrice(price: string): string {
  const cleaned = price.replace(/^\$+/, "");
  return `$${cleaned}`;
}

export function getLowestPrice(
  shopPrice: string | null,
  bundles?: Array<{ name?: string; price?: string; description?: string }> | null
): { label: string; amount: string } | null {
  if (bundles && bundles.length > 0) {
    const prices = bundles
      .map((b) => {
        const match = b.price?.replace(/[^0-9.]/g, "");
        return match ? parseFloat(match) : null;
      })
      .filter((p): p is number => p !== null && !isNaN(p));
    if (prices.length > 0) {
      const min = Math.min(...prices);
      return { label: "Starting at", amount: `$${min.toFixed(2)}` };
    }
  }
  if (shopPrice) {
    const cleaned = shopPrice.replace(/^\$+/, "");
    return { label: "", amount: `$${cleaned}` };
  }
  return null;
}
